import { useIntl } from "react-intl";

export const useNotificationTranslation = () => {
  const intl = useIntl();

  const autoBuyNotificationText = intl.formatMessage({
    id: "autobuyNotification",
  });
  const saveSettingsText = intl.formatMessage({
    id: "saveSettings",
  });
  const orderWindowEmailText = intl.formatMessage({
    id: "orderWindowEmail",
  });
  const reminderEmailtext = intl.formatMessage({
    id: "reminderEmail",
  });

  return {
    autoBuyNotificationText,
    saveSettingsText,
    orderWindowEmailText,
    reminderEmailtext,
  };
};
